import { render, staticRenderFns } from "./MarkList.vue.html?vue&type=template&id=ffb6b6a6&lang=html&external"
import script from "./MarkList.vue.js?vue&type=script&lang=js&external"
export * from "./MarkList.vue.js?vue&type=script&lang=js&external"
import style0 from "./MarkList.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports